import { SarlaftFilter } from '../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftFilter = {
    caseId: '',
    account: '',
    status: '',
    numberForm: '',
    typification1: '',
    typification2: '',
    startCreatedAt: undefined,
    endCreatedAt: undefined,
};
